/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import i18n from 'i18n';
import {
  editOperatorRequest,
  resetPasswordRequest,
} from 'modules/operators/actions';
import { messagesRequest } from 'modules/messages/actions';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { GetOperatorFields } from 'modules/operators/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

interface IntroModalProps {
  operator: GetOperatorFields;
  isLoading: boolean;
  onCancel: () => void;
  editOperatorRequest: (props: { values: any }) => void;
  resetPasswordRequest: ({ email, recaptcha_token }) => void;
  messagesRequest: (props: { type: string; message: string }) => void;
  setSkipIntro: React.Dispatch<React.SetStateAction<boolean>>;
}

const IntroModal = ({
  operator,
  isLoading,
  onCancel,
  resetPasswordRequest,
  messagesRequest,
  setSkipIntro,
}: IntroModalProps) => {
  const classes = useStyles();

  const handleSendEmail = () => {
    // eslint-disable-next-line no-undef
    grecaptcha
      .execute(process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!, {
        action: 'autosky_admin_operator_reset_password',
      })
      .then(token => {
        resetPasswordRequest({
          email: operator?.email,
          'recaptcha_token': token,
        });
      });
    messagesRequest({
      type: 'success',
      message: i18n.t('EMAIL_SENT_KEY'),
    });

    onCancel();
  };

  return (
    <Grid item xs={12}>
      <Grid container justify="center" className={classes.buttons}>
        <Button
          size="large"
          variant="outlined"
          onClick={handleSendEmail}
          isLoading={isLoading}
        >
          {i18n.t('SEND_BY_EMAIL_KEY')}
        </Button>
        <div
          className="g-recaptcha"
          data-sitekey={process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY_ADMIN_20!}
          data-callback="handleSendEmail"
          data-size="invisible"
          data-badge="bottomright"
        />
        <Button
          size="large"
          variant="outlined"
          onClick={() => setSkipIntro(true)}
        >
          {i18n.t('INSERT_MANUALLY_KEY')}
        </Button>
      </Grid>
      <small>
        {i18n.t('GOOGLE_RECAPTCHA_SITE_KEY')}
        <a
          className={classes.privacyAndTerms}
          href="https://policies.google.com/privacy"
        >
          Privacy Policy
        </a>{' '}
        and
        <a
          className={classes.privacyAndTerms}
          href="https://policies.google.com/terms"
        >
          Terms of Service
        </a>{' '}
        apply.
      </small>
      <Grid container className={classes.footerDivider}>
        <Grid container justify="flex-end">
          <Button
            className={classes.cancelButton}
            id="cancel-button"
            variant="outlined"
            onClick={onCancel}
          >
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({ operators: { isLoading } }: ApplicationState) => ({
  isLoading,
});

export default connect(mapStateToProps, {
  editOperatorRequest,
  resetPasswordRequest,
  messagesRequest,
})(IntroModal);
